import { useSelector } from 'react-redux';

export function useCampusCostsIncluded() {
  return useSelector((state: AppState) => state.globals?.server?.campusCostsIncluded || '');
}
